<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters.getUserDetails);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const currentLocation = computed(() => store.getters.getCurrentLocation);
const locations = computed(() => store.getters.getLocations || []);
const switchingLocation = ref(false);
const canSwitchLocation = computed(() => locations.value.length > 1);
const userDetails = computed(() => {
    const attributes = user.value;
    
    if (!Array.isArray(attributes)) {
        return null; 
    }
    
    const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
    const nameAttr = attributes.find(attr => attr.Name === 'name');
    
    return roleAttr && nameAttr ? {role:roleAttr.Value,name:nameAttr.Value} : null;
});

const handleLocationChange = async (locationid) => {
    if (!locationid || locationid === currentLocation.value?.locationid) {
        return;
    }

    switchingLocation.value = true;
    try {
        await store.dispatch('switchLocation', locationid);
        router.go(0);
    } finally {
        switchingLocation.value = false;
    }
};

const handleSignOut = async () => {
    await store.dispatch('logout');
    router.replace({ name: 'signin' });
};
</script>

<template>
    <ul class="nav user-menu">
        <li class="nav-item nav-searchinputs">
            <div class="top-nav-search">
                
            </div>
        </li>
        <li class="nav-item nav-item-box">
            <a href="javascript:void(0);" id="btnFullscreen" @click="initFullScreen">
                <vue-feather type="maximize"></vue-feather>
            </a>
        </li>
        <li v-if="isAuthenticated && currentLocation" class="nav-item nav-location-select">
            <div class="dropdown location-switcher">
                <button
                    class="location-trigger"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    :disabled="switchingLocation || !canSwitchLocation"
                >
                    <span class="location-icon">
                        <vue-feather type="map-pin"></vue-feather>
                    </span>
                    <span class="location-copy">
                        <span class="location-label">Current Location</span>
                        <strong>{{ currentLocation.locationname }}</strong>
                    </span>
                    <span class="location-caret">
                        <span v-if="switchingLocation" class="spinner-border spinner-border-sm" role="status"></span>
                        <vue-feather v-else-if="canSwitchLocation" type="chevron-down"></vue-feather>
                    </span>
                </button>
                <div class="dropdown-menu dropdown-menu-end location-menu">
                    <div class="location-menu-title">Switch location</div>
                    <button
                        v-for="location in locations"
                        :key="location.locationid"
                        type="button"
                        class="dropdown-item location-menu-item"
                        :class="{ active: location.locationid === currentLocation.locationid }"
                        @click="handleLocationChange(location.locationid)"
                    >
                        <span class="location-menu-icon">
                            <vue-feather type="map-pin"></vue-feather>
                        </span>
                        <span>
                            <strong>{{ location.locationname }}</strong>
                            <small>{{ location.locationtype || location.locationid }}</small>
                        </span>
                        <vue-feather
                            v-if="location.locationid === currentLocation.locationid"
                            class="location-check"
                            type="check"
                        ></vue-feather>
                    </button>
                </div>
            </div>
        </li>
        <template v-if="isAuthenticated">
            <li class="nav-item dropdown has-arrow main-drop">
                <a
                    href="javascript:void(0);"
                    class="dropdown-toggle nav-link userset"
                    data-bs-toggle="dropdown"
                >
                    <span class="user-info">
                        <span class="user-letter">
                            <img src="../assets/img/profiles/avator1.jpg" alt="" class="img-fluid" />
                        </span>
                        <span class="user-detail">
                            <span class="user-name">{{userDetails?.name}}</span>
                            <span class="user-role">{{userDetails?.role}}</span>
                        </span>
                    </span>
                </a>
                <div class="dropdown-menu menu-drop-user">
                    <div class="profilename">
                        <div class="profileset">
                            <span class="user-img"
                                ><img src="../assets/img/profiles/avator1.jpg" alt="" />
                                <span class="status online"></span
                            ></span>
                            <div class="profilesets">
                                <h6>{{userDetails?.name}}</h6>
                                <h5>{{userDetails?.role}}</h5>
                            </div>
                        </div>
                        <hr class="m-0" />
                        <hr class="m-0" />
                        <a class="dropdown-item logout pb-0" href="javascript:void(0);" @click.prevent="handleSignOut"
                            ><img
                                src="../assets/img/icons/log-out.svg"
                                class="me-2"
                                alt="img"
                                
                            />Logout</a
                        >
                    </div>
                </div>
            </li>
        </template>
    </ul>
    </template>
<script>
import headernotification from "../assets/json/headernotification.json";
export default {
    data() {
        return {
            headernotification: headernotification
        };
    },
    methods: {
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (
                !document.fullscreenElement &&
                /* alternative standard method */
                !document.mozFullScreenElement &&
                !document.webkitFullscreenElement
            ) {
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
    }
};
</script>
<style scoped>
.nav-location-select {
    display: flex;
    align-items: center;
}

.location-switcher {
    min-width: 230px;
}

.location-trigger {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    color: #0f172a;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.location-trigger:hover:not(:disabled),
.location-trigger:focus {
    border-color: #ff9f43;
    box-shadow: 0 10px 24px rgba(255, 159, 67, 0.16);
    transform: translateY(-1px);
    outline: none;
}

.location-trigger:disabled {
    cursor: default;
    opacity: 1;
}

.location-icon,
.location-menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    border-radius: 10px;
    background: #fff7ed;
    color: #f97316;
}

.location-icon :deep(svg),
.location-menu-icon :deep(svg),
.location-caret :deep(svg),
.location-check :deep(svg) {
    width: 16px;
    height: 16px;
}

.location-copy {
    min-width: 0;
    flex: 1;
    text-align: left;
}

.location-label {
    display: block;
    margin-bottom: 2px;
    color: #64748b;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1;
    text-transform: uppercase;
}

.location-copy strong {
    display: block;
    overflow: hidden;
    color: #0f172a;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.location-caret {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    color: #94a3b8;
}

.location-menu {
    width: 280px;
    padding: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16);
}

.location-menu-title {
    padding: 8px 10px 6px;
    color: #64748b;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

.location-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    color: #0f172a;
}

.location-menu-item strong,
.location-menu-item small {
    display: block;
}

.location-menu-item strong {
    font-size: 13px;
    line-height: 1.2;
}

.location-menu-item small {
    margin-top: 2px;
    color: #64748b;
    font-size: 11px;
}

.location-menu-item:hover,
.location-menu-item:focus {
    background: #fff7ed;
    color: #9a3412;
}

.location-menu-item.active {
    background: #ffedd5;
    color: #9a3412;
}

.location-menu-item.active .location-menu-icon {
    background: #ffffff;
}

.location-check {
    margin-left: auto;
    color: #16a34a;
}

@media (max-width: 767px) {
    .location-switcher {
        min-width: 190px;
    }

    .location-trigger {
        padding: 7px 9px;
    }

    .location-icon {
        display: none;
    }
}
</style>
